
/* -------------------------------------------------------------------------------- *\
|                               formatdateYYYYMMDD
\* -------------------------------------------------------------------------------- */
export const formatdateYYYYMMDD = (date: Date): string =>
{
    const y: number = date.getUTCFullYear();
    const m: number = date.getUTCMonth() + 1;
    const d: number = date.getUTCDate();

    return String(y).padStart(4, '0') + String(m).padStart(2, '0') + String(d).padStart(2, '0');
}
/* -------------------------------------------------------------------------------- *\
|                               MLEvent
\* -------------------------------------------------------------------------------- */
export class MLEvent
{
    public created: string = "";
    public filename: string = "";
    public meetingdate: string = "";
    public number: number = 0;
    public sic: string = "";
    public type: string = "";
    public race: number = 0;
    public competitor: number = 0;
    public content: string = "";
    public error: string = "";
    public date: number = new Date().getTime();
}
/* -------------------------------------------------------------------------------- *\
|                               MLEventSaved
\* -------------------------------------------------------------------------------- */
export class MLEventSaved
{
    public created: number = 0;
    public context: string = "";
    public source: string = "";
    public beforerace: MLRace | null = new MLRace();
    public afterrace: MLRace = new MLRace();
    public date: number = new Date().getTime();
}
/* -------------------------------------------------------------------------------- *\
|                               MLCompetitor
\* -------------------------------------------------------------------------------- */
export class MLCompetitor
{
    public number: number = 0;
    public name: string = "";
    public distance: number = 0;
    public status: string = "";
    public driver: string = "";
    public trainer: string = "";
    public owner: string = "";
    public draw: number = 0;
    public rank: number = 0;
    public time: string = "";
    public urlsilk: string = "";
}
/* -------------------------------------------------------------------------------- *\
|                               MLRace
\* -------------------------------------------------------------------------------- */
export class MLRace
{
    public meeting: number = 0;
    public meetingdate: string = "";
    public number: number = 0;
    public sic: string = "";
    public trackname: string = "";
    public state: string = "";
    public trackcode: string = "";
    public name: string = "";
    public date: string = "";
    public distance: number = 0;
    public type: string = ""; // CROSS TROT STEEPLE PLAT MONTÉ ATTELÉ HAIES
    public source: string = ""; // ICP GOLDCIRCLE CAPIDA MST USER
    public comment: string = ""; // user comment

    public competitors: MLCompetitor[] = [];

    public day: string = "";
    public time: string = "";

}
/* -------------------------------------------------------------------------------- *\
|                               CalpinMeeting
|   French meeting planned in calpin (server: calpin.ts)
\* -------------------------------------------------------------------------------- */
export interface CalpinMeeting
{
    date: string;           // YYYYMMDD
    start: string;          // ISO date of the first race
    sic: string;
    name: string;
    number: number;
    races: number;
    specialty: string;
    status: string;
}
export interface CalpinFile
{
    updated: string;
    from: string;
    to: string;
    meetings: CalpinMeeting[];
}
/* -------------------------------------------------------------------------------- *\
|                               SkyRacingMeeting
|   Australian meeting planned in the Sky Racing schedule (server: skyracing.ts)
\* -------------------------------------------------------------------------------- */
export interface SkyRacingRace
{
    number: number;
    time: string;           // ISO date
}
export interface SkyRacingMeeting
{
    date: string;           // YYYYMMDD
    start: string;          // ISO date of the first race
    sic: string;
    name: string;
    type: string;
    races: number;
    times: SkyRacingRace[];
}
export interface SkyRacingFile
{
    updated: string;
    from: string;
    to: string;
    meetings: SkyRacingMeeting[];
}
/* -------------------------------------------------------------------------------- *\
|                               MLMeeting
\* -------------------------------------------------------------------------------- */
export class MLMeeting
{
    public meeting: number = 0;
    public sic: string = "";
    public date: string = "";

    public races: MLRace[] = [];
    public events: MLEvent[] = [];
}
/* -------------------------------------------------------------------------------- *\
|                               APIAnswer
\* -------------------------------------------------------------------------------- */
export class APIAnswer
{
    public status: boolean = false;
    public message: string = "";
}
/* -------------------------------------------------------------------------------- *\
|                               APIAnswerData
\* -------------------------------------------------------------------------------- */
export class APIAnswerData
{
    public status: boolean = false;
    public message: string = "";
    public data: any = null;
}
/* -------------------------------------------------------------------------------- *\
|                               Track
\* -------------------------------------------------------------------------------- */
export class Track
{
	public sic: string = "";
	public code: string = "";
	public type: string = ""; // CROSS TROT STEEPLE PLAT MONTÉ ATTELÉ HAIES
    public distance: number = 0;
}
/* -------------------------------------------------------------------------------- *\
|                               Venue
\* -------------------------------------------------------------------------------- */
export class Venue
{
	public name: string = "";
	public sic: string = "";
	public source: string = "";
    public tracks: Track[] = [];
}
/* -------------------------------------------------------------------------------- *\
|                               JUMPS
\* -------------------------------------------------------------------------------- */
export type JumpType =
{
    key: string;
    text: string;
}
/* -------------------------------------------------------------------------------- *\
|                               JUMPS
\* -------------------------------------------------------------------------------- */
export const JUMPS: JumpType[] =
[
    { "key": "HAIE", "text": "Haie" },

    { "key": "BABO", "text": "Banquette 'de bordeaux'" },
    { "key": "BAIR", "text": "Banquette irlandaise" },
    { "key": "BANQ", "text": "Banquette" },
    { "key": "BROO", "text": "Brook" },
    { "key": "BUFI", "text": "Bull finch" },
    { "key": "BUTR", "text": "Butte en terre" },
    { "key": "BUTT", "text": "Butte" },
    { "key": "CHGE", "text": "Chapeau de gendarme" },
    { "key": "COHA", "text": "Contre haut" },
    { "key": "COBA", "text": "Contre bas" },
    { "key": "DBAR", "text": "Double barrière" },
    { "key": "DCRO", "text": "Double croche" },
    { "key": "DEFE", "text": "Demi fence" },
    { "key": "DERH", "text": "Dernière haie" },
    { "key": "DESC", "text": "Descente" },
    { "key": "FEIR", "text": "Fence Irlandais" },
    { "key": "FENC", "text": "Fence" },
    { "key": "FOSS", "text": "Fossé" },
    { "key": "GCOB", "text": "Gros contre bas" },
    { "key": "GCOH", "text": "Gros contre haut" },
    { "key": "GODI", "text": "Gros open ditch" },
    { "key": "GPRO", "text": "Gros passage de route" },
    { "key": "GUEE", "text": "Gué" },
    { "key": "GHAI", "text": "Grosse haie" },
    { "key": "GRIM", "text": "Grimpette" },
    { "key": "HAAM", "text": "Haie mobile" },
    { "key": "HANO", "text": "Haie noire" },
    { "key": "HAPI", "text": "Haie pivotante" },
    { "key": "HAVE", "text": "Haie verte" },
    { "key": "HAVI", "text": "Haie vive" },
    { "key": "MODI", "text": "Moyen open ditch" },
    { "key": "MUPI", "text": "Mur en pierre" },
    { "key": "MUTE", "text": "Mur en terre" },
    { "key": "ODIT", "text": "Open ditch" },
    { "key": "ODIV", "text": "Open ditch vert" },
    { "key": "OXER", "text": "Oxer" },
    { "key": "OXHA", "text": "Oxer de Haies" },
    { "key": "OXMO", "text": "Oxer Montant" },
    { "key": "PAMO", "text": "Parc à moutons" },
    { "key": "PARO", "text": "Passage de route" },
    { "key": "PASO", "text": "Passage obligé" },
    { "key": "PCHA", "text": "Petit contre haut" },
    { "key": "PEFE", "text": "Petit Fence" },
    { "key": "PETA", "text": "Petit Talus" },
    { "key": "PIAD", "text": "Piano à descendre" },
    { "key": "PIAM", "text": "Piano à monter" },
    { "key": "PODI", "text": "Petit open ditch" },
    { "key": "PPRO", "text": "Petit passage de route" },
    { "key": "RDFE", "text": "Rail Ditch and Fence" },
    { "key": "RHUI", "text": "Plage d'Auteuil" },
    { "key": "RTRI", "text": "Riviere des tribunes" },
    { "key": "RIVI", "text": "Rivière" },
    { "key": "TALU", "text": "Talus" },
    { "key": "TATE", "text": "Talus en terre" },
    { "key": "TRAR", "text": "Tronc d'arbre" },
    { "key": "TRBF", "text": "Trou à bord franc" },
    { "key": "TALA", "text": "Talus Landais" },
    { "key": "TABR", "text": "Talus Breton" },
    { "key": "VOLP", "text": "Volpoom" }
];

/* -------------------------------------------------------------------------------- *\
|                               TrackPoint
\* -------------------------------------------------------------------------------- */
export class TrackPoint
{
    public distance: number = 0;
    public lat_int: number = 0;
    public lon_int: number = 0;
    public lat_mid: number = 0;
    public lon_mid: number = 0;
    public lat_ext: number = 0;
    public lon_ext: number = 0;
    public extra: string = "";
}
/* -------------------------------------------------------------------------------- *\
|                               TrackInfos
\* -------------------------------------------------------------------------------- */
export class TrackInfos
{
    public dist_official: number = 0;
    public dist_pcdep: number = 0;
    public dist_total: number = 0;
    public withyards: boolean = false;
    public jumps: TrackPoint[] = [];
}
/* -------------------------------------------------------------------------------- *\
|                               Jumps
\* -------------------------------------------------------------------------------- */
export class JumpInfos
{
    public distance: number = 0;
    public number: number = 0;
    public key: string = "";
    public text: string = "";
    public position: TrackPoint | null = null;
    public pcs: TrackPoint | null = null;
    public pca: TrackPoint | null = null;
}
/* -------------------------------------------------------------------------------- *\
|                               VenueInfo
\* -------------------------------------------------------------------------------- */
export class VenueInfo
{
    public sic: string = "";
    public name: string = "";
}
/* -------------------------------------------------------------------------------- *\
|                               MLIMU
\* -------------------------------------------------------------------------------- */
export class MLIMU
{
    public filename: string = "";
    public date: string = "";
    public sic: string = "";
    public number: number = 0;
}
/* -------------------------------------------------------------------------------- *\
|                               UbxNavPvt
\* -------------------------------------------------------------------------------- */
export interface UbxNavPvt
{
    iTOW: number;        // GPS time of week (ms)
    year: number;
    month: number;
    day: number;
    hour: number;
    min: number;
    sec: number;
    valid: number;       // validity flags (bitmask)
    tAcc: number;        // time accuracy estimate (ns)
    nano: number;        // fraction of second (ns)
    fixType: number;     // 0=no fix,1=dead reckoning,2=2D,3=3D,4=GNSS+DR,5=time only
    flags: number;
    flags2: number;
    numSV: number;
    lon: number;         // longitude (deg)
    lat: number;         // latitude (deg)
    height: number;      // height above ellipsoid (m)
    hMSL: number;        // height above MSL (m)
    hAcc: number;        // horizontal accuracy (m)
    vAcc: number;        // vertical accuracy (m)
    velN: number;        // NED north velocity (m/s)
    velE: number;        // NED east velocity (m/s)
    velD: number;        // NED down velocity (m/s)
    gSpeed: number;      // ground speed 2D (m/s)
    headMot: number;     // heading of motion 2D (deg)
    sAcc: number;        // speed accuracy (m/s)
    headAcc: number;     // heading accuracy (deg)
    pDOP: number;        // position DOP
    headVeh: number;     // heading of vehicle (deg)
    magDec: number;      // magnetic declination (deg)
    magAcc: number;      // magnetic declination accuracy (deg)
}
/* -------------------------------------------------------------------------------- *\
|                               ImuSample
\* -------------------------------------------------------------------------------- */
export interface ImuSample
{
    gyroX: number;
    gyroY: number;
    gyroZ: number;
    xlX: number;
    xlY: number;
    xlZ: number;
}
/* -------------------------------------------------------------------------------- *\
|                               ImuDataBlock
\* -------------------------------------------------------------------------------- */
export interface ImuDataBlock
{
    timestamp: number;
    latitude: number;
    longitude: number;
    samples: ImuSample[];
    ubxNavPvt: UbxNavPvt | null;

    valid: boolean;
}
/* -------------------------------------------------------------------------------- *\
|                               ImuFileBlock
\* -------------------------------------------------------------------------------- */
export interface ImuFileBlock
{
    blockNumber: number;
    data: ImuDataBlock | null;
}
/* -------------------------------------------------------------------------------- *\
|                               MLImuMeeting
\* -------------------------------------------------------------------------------- */
export class MLImuMeeting
{
    public meetingdate: string = "";
    public sic: string = "";
    public files: MLIMU[] = [];
}
